export const notFound = {
  shape: `<text fill="black" font-family="SF Pro Display" font-size="24" font-weight="bold" letter-spacing="0em"><tspan x="0" y="24.18">⚠</tspan></text>`,
};
